// TODO: Локализация
export const InvoiceCreatorItemGridPluginSettings = (): IPluginSettings => {
    let index = 0
    return {
        name: "Позиции",
        mnemocode: "invoice_item_create_plugin",
        permission: "Invoice",
        columns: [
            {
                order: index++,
                propertyName: "alert",
                propertyType: "string",
                displayName: "",
                visibility: true,
                width: 60,
            },
            {
                order: index++,
                propertyName: "lineStatus",
                propertyType: "string",
                displayName: "Статус строки",
                visibility: true,
                width: 60,
            },
            {
                order: index++,
                propertyName: "idGlobal",
                propertyType: "string",
                displayName: "idGlobal",
                visibility: false,
                width: 100,
            },
            {
                order: index++,
                propertyName: "idGoodsGlobal",
                propertyType: "string",
                displayName: "idGoodsGlobal",
                visibility: false,
                width: 100,
            },
            {
                order: index++,
                propertyName: "goodsName",
                propertyType: "string",
                displayName: "Товар",
                visibility: true,
                width: 150,
            },
            {
                order: index++,
                propertyName: "scalingRatioName",
                propertyType: "string",
                displayName: "Упаковка",
                visibility: true,
                width: 150,
            },
            {
                order: index++,
                propertyName: "quantity",
                propertyType: "number",
                displayName: "Количество",
                visibility: true,
                width: 150,
                changeable: true,
            },
            {
                order: index++,
                propertyName: "actualQuantity",
                propertyType: "number",
                displayName: "Количество факт.",
                visibility: true,
                width: 150,
            },
            {
                order: index++,
                propertyName: "damageQuantity",
                propertyType: "number",
                displayName: "Бой",
                visibility: true,
                width: 150,
                changeable: true,
            },
            {
                order: index++,
                propertyName: "defectQuantity",
                propertyType: "number",
                displayName: "Брак",
                visibility: true,
                width: 150,
                changeable: true,
            },
            {
                order: index++,
                propertyName: "shortageQuantity",
                propertyType: "number",
                displayName: "Недостача",
                visibility: true,
                width: 150,
                changeable: true,
            },
            {
                order: index++,
                propertyName: "retailPriceIncVat",
                propertyType: "decimal",
                displayName: "Цена с НДС, розн.",
                visibility: true,
                width: 150,
                changeable: true,
            },
            {
                order: index++,
                propertyName: "gtin",
                propertyType: "string",
                displayName: "Gtin",
                visibility: true,
                width: 150,
                changeable: true,
            },
            {
                order: index++,
                propertyName: "retailAmount",
                propertyType: "number",
                displayName: "Сумма розничная",
                visibility: true,
                width: 150,
            },
            {
                order: index++,
                propertyName: "retailAmountIncVat",
                propertyType: "number",
                displayName: "Сумма розничная с НДС",
                visibility: true,
                width: 150,
            },
            {
                order: index++,
                propertyName: "retailVat",
                propertyType: "number",
                displayName: "НДС розничная",
                visibility: true,
                width: 150,
            },
            {
                order: index++,
                propertyName: "supplierAmount",
                propertyType: "number",
                displayName: "Сумма поставщика",
                visibility: true,
                width: 150,
            },
            {
                order: index++,
                propertyName: "supplierAmountIncVat",
                propertyType: "number",
                displayName: "Сумма поставщика с НДС",
                visibility: true,
                width: 150,
            },
            {
                order: index++,
                propertyName: "supplierPrice",
                propertyType: "number",
                displayName: "Цена поставщика",
                visibility: true,
                width: 150,
            },
            {
                order: index++,
                propertyName: "supplierPriceIncVat",
                propertyType: "number",
                displayName: "Цена с НДС, пост.",
                visibility: true,
                width: 150,
            },
            {
                order: index++,
                propertyName: "supplierVat",
                propertyType: "number",
                displayName: "НДС поставщика",
                visibility: true,
                width: 150,
            },
            {
                order: index++,
                propertyName: "producerPrice",
                propertyType: "number",
                displayName: "Цена производителя",
                visibility: true,
                width: 150,
            },
            {
                order: index++,
                propertyName: "productMargin",
                propertyType: "number",
                displayName: "Наценка розн.",
                visibility: true,
                width: 150,
                changeable: true,
        },
            {
                order: index++,
                propertyName: "isKiz",
                propertyType: "boolean",
                displayName: "Ввод киз",
                visibility: true,
                width: 150,
            },
            {
                order: index++,
                propertyName: "isGnvls",
                propertyType: "boolean",
                displayName: "ЖНВЛП",
                visibility: true,
                width: 150,
            },
            {
                order: index++,
                propertyName: "countKizScan",
                propertyType: "number",
                displayName: "Кол-во отсканированных кизов",
                visibility: true,
                width: 150,
            },
            {
                order: index++,
                propertyName: "numerator",
                propertyType: "number",
                displayName: "Числитель",
                visibility: false,
                width: 150,
            },
            {
                order: index++,
                propertyName: "denominator",
                propertyType: "number",
                displayName: "Знаменатель",
                visibility: false,
                width: 150,
            },
            {
                order: index++,
                propertyName: "retailPrice",
                propertyType: "number",
                displayName: "Цена без НДС розн.",
                visibility: true,
                width: 150,
            },
            {
                order: index++,
                propertyName: "idInvoiceItemGroupGlobal",
                propertyType: "string",
                displayName: "Группа пересорта",
                visibility: false,
                width: 200,
            },
            {
                order: index++,
                propertyName: "seriesNumber",
                propertyType: "string",
                displayName: "Серия",
                visibility: true,
                width: 200,
            },
            {
                order: index++,
                propertyName: "bestBefore",
                propertyType: "date",
                displayName: "Срок годности",
                visibility: true,
                width: 200,
            },
            {
                order: index++,
                propertyName: "isOsu",
                propertyType: "boolean",
                displayName: "Признак воды",
                visibility: true,
                width: 200,
            },
            {
                order: index++,
                propertyName: "goodsCode",
                propertyType: "string",
                displayName: "Код товара",
                visibility: true,
                width: 200,
            },
            {
                order: 32,
                propertyName: "producer",
                propertyType: "string",
                displayName: "Производитель",
                visibility: true,
                width: 200,
            },
            {
                order: index++,
                propertyName: "storePlaceName",
                propertyType: "string",
                displayName: "Место хранения",
                visibility: true,
                width: 200,
            },
        ],
    }
};
